// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { documentTemplateId } from './DocumentTemplate';
import { documentTemplateVersionId } from './DocumentTemplateVersion';
import { operatorId } from './Operator';
import { z } from 'zod';
export const documentSignedRecordId = (z.number());
export const documentSignedRecord = z.object({
    id: documentSignedRecordId,
    template_id: documentTemplateId,
    template_version_id: documentTemplateVersionId,
    operator_id: operatorId.nullable(),
    email: z.string(),
    full_name: z.string(),
    signature_path: z.string(),
    document_path: z.string().nullable(),
    user_agent: z.string().nullable(),
    content_hash: z.string().nullable(),
    signed_at: z.date(),
    invalidated_at: z.date().nullable(),
});
export const documentSignedRecordInitializer = z.object({
    id: documentSignedRecordId.optional(),
    template_id: documentTemplateId,
    template_version_id: documentTemplateVersionId,
    operator_id: operatorId.optional().nullable(),
    email: z.string(),
    full_name: z.string(),
    signature_path: z.string(),
    document_path: z.string().optional().nullable(),
    user_agent: z.string().optional().nullable(),
    content_hash: z.string().optional().nullable(),
    signed_at: z.date().optional(),
    invalidated_at: z.date().optional().nullable(),
});
export const documentSignedRecordMutator = z.object({
    id: documentSignedRecordId.optional(),
    template_id: documentTemplateId.optional(),
    template_version_id: documentTemplateVersionId.optional(),
    operator_id: operatorId.optional().nullable(),
    email: z.string().optional(),
    full_name: z.string().optional(),
    signature_path: z.string().optional(),
    document_path: z.string().optional().nullable(),
    user_agent: z.string().optional().nullable(),
    content_hash: z.string().optional().nullable(),
    signed_at: z.date().optional(),
    invalidated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=DocumentSignedRecord.js.map